<script>
  import { nav, go } from '../lib/nav.svelte.js';
  import { session, signOut, mayVisit, institution } from '../lib/session.svelte.js';
  import { SELF } from '../../shared/config.js';
  import Button from './Button.svelte';

  // What the institution has, shares and compares first; how it is done sits
  // under Advanced (docs/ref-belonging-plan.md, step 3).
  const links = [
    { route: 'overview', label: 'Overview' },
    { route: 'partners', label: 'Partners' },
    // Route ids are internal and stable; the label is what changed.
    { route: 'analysis', label: 'Comparisons' },
  ];
  // The pipeline, in the order the work flows: the terms, sources in, records,
  // cubes out.
  const advanced = [
    // How the datasets are put together, before the screens that do it.
    { route: 'advanced', label: 'Overview' },
    { route: 'schemas', label: 'Schemas' },
    { route: 'sources', label: 'Sources' },
    { route: 'records', label: 'Records' },
    { route: 'catalog', label: 'Cubes' },
  ];

  // Only show what this login's roles actually work with.
  const visible = $derived(links.filter((l) => mayVisit(l.route)));
  const visibleAdvanced = $derived(advanced.filter((l) => mayVisit(l.route)));

  // Highlight the top-level section for nested routes (source/mapping etc.).
  const section = $derived(nav.route.split('/')[0]);
  // Uploading a file (connector) and a source's mapping are part of Sources.
  const inSources = $derived(['sources', 'source'].includes(section));
  const inAdvanced = $derived(inSources || advanced.map((l) => l.route).includes(section));

  // The Advanced menu closes once you pick a screen or click elsewhere.
  let menuOpen = $state(false);
  let menu = $state(null);
  $effect(() => { nav.route; menuOpen = false; });
  const closeOutside = (event) => { if (menuOpen && !menu?.contains(event.target)) menuOpen = false; };

  async function doSignOut() {
    await signOut();
    go('login');
  }
</script>

<svelte:window onclick={closeOutside} />

<header class="wf2-header app-header">
  <a class="app-brand" href="#/overview">
    {institution().name}
    {#if institution().tagline}<small>{institution().tagline}</small>{/if}
  </a>

  {#if session.user}
    <nav class="app-nav">
      {#each visible as l}
        <!-- A dataset's page is opened from the Overview, so it counts as there. -->
        <a href={'#/' + l.route} class={section === l.route || (l.route === 'overview' && section === 'data') ? 'active' : ''}>{l.label}</a>
      {/each}
      {#if visibleAdvanced.length}
        <details class="app-navmenu" bind:open={menuOpen} bind:this={menu}>
          <summary class={inAdvanced ? 'active' : ''}>Advanced</summary>
          <div class="app-navmenu-items">
            {#each visibleAdvanced as l}
              <a href={'#/' + l.route} class={section === l.route || (l.route === 'sources' && inSources) ? 'active' : ''}>{l.label}</a>
            {/each}
          </div>
        </details>
      {/if}
    </nav>
    <div class="app-headend">
      <!-- The login is who you are here; the WebID is what the institution is
           to its partners. Showing both keeps the distinction visible. -->
      <div class="app-whoami">
        <a href="#/account">{session.user.name}</a><br /><code>{SELF.webId}</code>
      </div>
      <Button variant="secondary" onclick={doSignOut}>Sign out</Button>
    </div>
  {/if}
</header>
